import type { JSX } from 'solid-js';
import { SESSION_TOKEN } from '../lib/session';
import { AccountStreamProviderContext, createAccountStreamHub } from '../lib/stream-topics';

// The app shell's ONE `/v1/streams` connection (`lib/stream-topics.ts` says why).
// Every live view under it registers its topics instead of opening a socket of
// its own, so a tab holds one connection whatever it has mounted.
//
// It wraps the whole shell, the chrome-less onboarding branch included: the hub
// dials nothing until something registers, so a route with no live view costs no
// connection and no server-side poll.

export function AccountStreamProvider(props: {
  token?: string | null;
  children?: JSX.Element;
}): JSX.Element {
  // An explicit `null` is a signed-out caller; only an OMITTED prop defaults to
  // the dev session (`Ci` / `Fleet`'s rule — `??` would replace the null).
  const token = props.token === undefined ? SESSION_TOKEN : props.token;
  const hub = createAccountStreamHub(token);
  return <AccountStreamProviderContext value={hub}>{props.children}</AccountStreamProviderContext>;
}
